import { render, staticRenderFns } from "./ScheduleWarningLabel.vue?vue&type=template&id=21495ff6&scoped=true&"
import script from "./ScheduleWarningLabel.vue?vue&type=script&lang=js&"
export * from "./ScheduleWarningLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21495ff6",
  null
  
)

export default component.exports